export enum TransitionTargetStatus {
  NOT_ACHIEVABLE = 0,
  ACHIEVABLE_LATER = 1,
  CAN_BE_STRETCHED = 2,
  CHALLENGING = 3,
  NOT_POSSIBLE = 4,
  AWAITING_STATUS = 5,
}
